<script lang="ts">import { browser } from "$app/environment";
import { CardSwiper } from "@infinitro/card-swiper";
import { GameCategory, getGames, toGameSlug, toProviderSlug } from "@infinitro/catalog-min";
import { FeatureSet, stateFeatureSet } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { providerBasePath, theme, Theme } from "@infinitro/global";
export let game;
const RELATED_LIMIT = 12;
const isFlush = theme === Theme.Flush;
let related = [];
$: isEnabled = isFlush && $stateFeatureSet === FeatureSet.Preview;
$: providerName = game?.prov ?? "";
$: currentSlug = game?.game_slug || toGameSlug(game?.game ?? "");
$: providerUrl = providerName ? `${providerBasePath(providerName)}${toProviderSlug(providerName)}/` : "";
$: if (browser && isEnabled && providerName) {
	void loadRelated(providerName, currentSlug);
}
async function loadRelated(prov, current) {
	try {
		const [games] = await getGames(1, RELATED_LIMIT + 1, prov, GameCategory.All);
		related = games.filter((g) => (g.game_slug || toGameSlug(g.game ?? "")) !== current).slice(0, RELATED_LIMIT);
	} catch {
		related = [];
	}
}
</script>

{#if isEnabled && related.length}
	<section class="related-games">
		<CardSwiper
			data={related}
			title={$t(Verbiage.more_games, 'global', { provider: providerName })}
			url={providerUrl}
			icon={null}
			irregular={true}
			minHeight={true}
		/>
	</section>
{/if}

<style>
	.related-games {
    margin-top: 2rem;
    margin-bottom: 3rem;
    width: 100%
}
</style>
